export enum CatalogTestIds {
  CATALOG_CARD_LINK_PREFIX = 'catalog-card-link-',
  CATALOG_CARD_PREFIX = 'catalog-card-',
  CATALOG_SEARCH_FIELD = 'catalog-search-field',
  CATALOG_TOTAL_ITEMS = 'catalog-total-items',
  CATALOG_MASS_ACTIONS_BAR = 'catalog-mass-actions-bar',
  CATALOG_CREATE_BUTTON = 'catalog-create-button',
  CATALOG_EMPTY_STATE = 'catalog-empty-state',
  CATALOG_CREATION_MODAL_NAME = 'catalog-creation-modal-name',
  CATALOG_CREATION_MODAL_CODE = 'catalog-creation-modal-code',
  CATALOG_CREATION_MODAL_PUBLIC_SHARING = 'catalog-creation-modal-public-sharing',
  CATALOG_CREATION_MODAL_STOCK_MIN_TOTAL_PIECES_PREFIX = 'catalog-creation-modal-stock-min-total-pieces-',
  CATALOG_CREATION_MODAL_STOCK_MIN_SEQUENTIAL_SIZES_PREFIX = 'catalog-creation-modal-stock-min-sequential-sizes-',
  CATALOG_CREATION_MODAL_SELECTION_METHOD = 'catalog-creation-modal-selection-method',
  CATALOG_CREATION_MODAL_CRITERIA_ADD = 'catalog-creation-modal-criteria-add',
  CATALOG_CREATION_MODAL_CRITERIA_CHIP_PREFIX = 'catalog-creation-modal-criteria-chip-',
  CATALOG_CREATION_MODAL_CRITERIA_POPOVER = 'catalog-creation-modal-criteria-popover',
  CATALOG_CREATION_MODAL_CRITERIA_TYPE_PREFIX = 'catalog-creation-modal-criteria-type-',
  CATALOG_CREATION_MODAL_CRITERIA_OPERATOR = 'catalog-creation-modal-criteria-operator',
  CATALOG_CREATION_MODAL_CRITERIA_SEARCH = 'catalog-creation-modal-criteria-search',
  CATALOG_CREATION_MODAL_CRITERIA_OPTION_PREFIX = 'catalog-creation-modal-criteria-option-',
  CATALOG_CREATION_MODAL_CRITERIA_APPLY = 'catalog-creation-modal-criteria-apply',
  CATALOG_CREATION_MODAL_DISPLAYED_COLORS = 'catalog-creation-modal-displayed-colors',
  CATALOG_CREATION_MODAL_UNAVAILABLE_PRODUCT_COLOR = 'catalog-creation-modal-unavailable-product-color',
  CATALOG_CREATION_MODAL_PRODUCT_COLOR_CARDS = 'catalog-creation-modal-product-color-cards',
  CATALOG_CREATION_MODAL_PRODUCT_WITHOUT_MEDIA = 'catalog-creation-modal-product-without-media',
  CATALOG_CREATION_MODAL_SORT_CRITERION = 'catalog-creation-modal-sort-criterion',
  CATALOG_CREATION_MODAL_RELATED_PRODUCTS = 'catalog-creation-modal-related-products',
  CATALOG_CREATION_MODAL_ACCESS_TAB_PREFIX = 'catalog-creation-modal-access-tab-',
  CATALOG_CREATION_MODAL_ACCESS_ADD = 'catalog-creation-modal-access-add',
  CATALOG_CREATION_MODAL_ACCESS_EMPTY = 'catalog-creation-modal-access-empty',
  CATALOG_CREATION_MODAL_ACCESS_START_DATE_PREFIX = 'catalog-creation-modal-access-start-date-',
  CATALOG_CREATION_MODAL_ACCESS_END_DATE_PREFIX = 'catalog-creation-modal-access-end-date-',
  CATALOG_CREATION_MODAL_ACCESS_REMOVE = 'catalog-creation-modal-access-remove',
  CATALOG_CREATION_MODAL_ACCESS_ADD_MODAL = 'catalog-creation-modal-access-add-modal',
  CATALOG_CREATION_MODAL_ACCESS_ADD_ENTITIES = 'catalog-creation-modal-access-add-entities',
  CATALOG_CREATION_MODAL_ACCESS_ADD_START_DATE = 'catalog-creation-modal-access-add-start-date',
  CATALOG_CREATION_MODAL_ACCESS_ADD_END_DATE = 'catalog-creation-modal-access-add-end-date',
  CATALOG_CREATION_MODAL_ACCESS_ADD_CONFIRM = 'catalog-creation-modal-access-add-confirm',
  CATALOG_CREATION_MODAL_ACCESS_ADD_CANCEL = 'catalog-creation-modal-access-add-cancel',
  CATALOG_CREATION_MODAL_SUBMIT = 'catalog-creation-modal-submit',
  CATALOG_CREATION_MODAL_CANCEL = 'catalog-creation-modal-cancel',
}

export enum CatalogListTabTestIds {
  TAB_ALL = 'catalog-list-tab-all',
  TAB_ACTIVE = 'catalog-list-tab-active',
  TAB_INACTIVE = 'catalog-list-tab-inactive',
  TAB_UNAVAILABLE = 'catalog-list-tab-unavailable',
}
